import { Button } from "@/components/ui/button";
import FormBox from "@/features/shared/components/FormBox";
import { useState } from "react";
import PasswordInputElement from "../../../../components/input/v1/PasswordInputElement";
import { PASSWORD_REGEX } from "../../../../utils/Constants";
import { PasswordInputIcon } from "../../../../utils/enums/PasswordInputIcon";
import { PasswordInputType } from "../../../../utils/enums/PasswordInputType";

interface Props {
    onSubmit: (inputData: { [key: string]: string }) => void;
}

const NewPasswordBox: React.FC<Props> = ({
    onSubmit,
}) => {
    const [inputs, setInputs] = useState<{ [key: string]: string }>({
        password: '',
        confirmPassword: '',
    });

    const isPasswordAcceptable = PASSWORD_REGEX.test(inputs.password)
    const isConfirmButtonEnabled = isPasswordAcceptable && inputs.password === inputs.confirmPassword

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setInputs((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        onSubmit(inputs);
    }

    // ********************************************************************************

    return (
        <FormBox
            title="Nuova Password"
            description="Inserisci e conferma una nuova password per il tuo account Holifya."
            formContent={
                <>
                    <div className="font-semibold text-xs text-center text-holifya-blue">
                        Una password valida è composta da almeno 8 caratteri di cui: almeno una Maiuscola, una minuscola, un numero e un simbolo speciale (!$%& ...)
                    </div>
                    <PasswordInputElement
                        name="password"
                        label="Nuova password"
                        placeholder="Nuova password"
                        disabled={false}
                        image={PasswordInputIcon.ShowDisabled}
                        type={PasswordInputType.Password}
                        inputValue={inputs.password}
                        toggleTypeEnabled={inputs.password !== ""}
                        onIconClick={() => console.log()}
                        onChange={handleInputChange}
                        errorText={""}
                        autoComplete="new-password"
                    />
                    <PasswordInputElement
                        name="confirmPassword"
                        label="Conferma password"
                        placeholder="Conferma password"
                        disabled={!isPasswordAcceptable}
                        image={PasswordInputIcon.ShowDisabled}
                        type={PasswordInputType.Password}
                        inputValue={inputs.confirmPassword}
                        toggleTypeEnabled={isPasswordAcceptable && inputs.confirmPassword !== ""}
                        onIconClick={() => console.log()}
                        onChange={handleInputChange}
                        errorText={""}
                        autoComplete="new-password"
                    />
                    <Button
                        size={'form'}
                        disabled={!isConfirmButtonEnabled}
                    >
                        Conferma Password
                    </Button>
                </>
            }
            onSubmit={handleSubmit}
        />
    )
}

export default NewPasswordBox
